<template>
  <div :id="id">
    <div
      class="alert alert-danger alert-dismissible fade show"
      role="alert"
      v-if="errorMessages.length"
    >
      <ul>
        <li v-for="(message, index) in errorMessages" :key="index">
          <span v-html="message"></span>
        </li>
      </ul>
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        @click="errorMessages.splice(0)"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div
      class="alert alert-warning alert-dismissible fade show"
      role="alert"
      v-if="warningMessages.length"
    >
      <ul>
        <li v-for="(message, index) in warningMessages" :key="index">
          <span v-html="message"></span>
        </li>
      </ul>
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        @click="warningMessages.splice(0)"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div
      class="alert alert-success alert-dismissible fade show"
      role="alert"
      v-if="successMessages.length"
    >
      <ul>
        <li v-for="(message, index) in successMessages" :key="index">
          <span v-html="message"></span>
        </li>
      </ul>
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        @click="successMessages.splice(0)"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: false,
    },
    errorMessages: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    warningMessages: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    successMessages: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
};
</script>
